export default (targetFilter, target, domElement = null) => {
  let el = target;

  do {
    if (targetFilter(el)) {
      return el;
    }

    if (domElement && domElement === el) {
      return null;
    }

    el = el.parentNode;
  } while (el);

  return null;
};



// WEBPACK FOOTER //
// ./src/lib/dom/element-closest.js